import React from "react";
import Section from "./Section";
import Banner from "./Banner";

const teamMembers = [
  {
    name: "Engin ERGEN",
    role: "Computer Engineer",
    image: "assets/images/team/team-01.jpeg",
    social: {
      linkedin: "https://www.linkedin.com/in/enginergen/",
      youtube: "https://www.youtube.com/@engin-ergen",
      instagram: "https://www.instagram.com/enginergen00/",
    },
  },
];

export default function Team({ isBanner = false, title = "Ekibimiz" }) {
  return (
    <>
      {isBanner ? <Banner title={title} /> : null}
      <Section id="team" className="ud-team">
        <div className="row">
          <div className="col-lg-12">
            <div className="ud-section-title mx-auto text-center">
              {isBanner ? null : <span>{title}</span>}
              <h2>Takımımızla Tanışın</h2>
              <p>
                Farklı alanlarda uzman ekibimizle birlikte apartman ve site
                yönetimlerini en iyi noktalara taşımayı hedefliyoruz.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-sm-6">
              <div
                className="ud-single-team wow fadeInUp"
                data-wow-delay={`${0.1 + index * 0.05}s`}
              >
                <div className="ud-team-image-wrapper">
                  <div className="ud-team-image">
                    <img src={member.image} alt={member.name} />
                  </div>

                  <img
                    src="assets/images/team/dotted-shape.svg"
                    alt="shape"
                    className="shape shape-1"
                  />
                  <img
                    src="assets/images/team/shape-2.svg"
                    alt="shape"
                    className="shape shape-2"
                  />
                </div>
                <div className="ud-team-info">
                  <h5>{member.name}</h5>
                  <h6>{member.role}</h6>
                </div>
                <ul className="ud-team-socials">
                  <li>
                    <a
                      href={member.social.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-youtube"></i>
                    </a>
                  </li>

                  <li>
                    <a
                      href={member.social.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-linkedin"></i>
                    </a>
                  </li>

                  <li>
                    <a
                      href={member.social.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lni lni-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
